import { LargeTitle, makeStyles, tokens } from '@fluentui/react-components';
import { Cell, Pie, PieChart } from 'recharts';

const WIDTH = 256;
const HEIGHT = 132;
const OUTER_RADIUS = 124;
const INNER_RADIUS = 86;

const useStyles = makeStyles({
  root: {
    position: 'relative',
    width: `${WIDTH}px`,
    height: `${HEIGHT}px`,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  value: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
    textAlign: 'center',
  },
});

type TProps = {
  percent: number;
};

export const HalfDonutChart = ({ percent }: TProps) => {
  const data = [{ value: percent }, { value: 100 - percent }];
  const classes = useStyles();
  return (
    <div className={classes.root}>
      <PieChart width={WIDTH} height={HEIGHT} margin={{ top: 0, right: 0, bottom: 0, left: 0 }}>
        <Pie
          dataKey="value"
          data={data}
          startAngle={180}
          endAngle={0}
          cx={WIDTH / 2}
          cy={OUTER_RADIUS + 4}
          innerRadius={INNER_RADIUS}
          outerRadius={OUTER_RADIUS}
          stroke="none"
        >
          <Cell fill={tokens.colorBrandForeground1} />
          <Cell fill={tokens.colorNeutralBackground4} />
        </Pie>
      </PieChart>
      <LargeTitle className={classes.value}>{percent}%</LargeTitle>
    </div>
  );
};
